import { SERVER } from "../../common/config/utils";

export const APPS_API_URL = "/store/learners/apps/";
export const PAGE_SIZE = 12;
export const APPS_LIST_PAGE_OG_IMAGE = `${SERVER}/apps/og-image.png`;
